import {HTTP} from '@/CallAPI'
export default {
  getListGroupFAQ (page = '', per_page = '', status = '') {
    return HTTP.get('group-faqs', {
      params: {
        page,
        per_page,
        status
      }
    })
  },

  showGroupFAQ (group_faq = {}) {
    return HTTP.get('group-faqs/' + group_faq.id)
  },

  createGroupFAQ (group_faq = {}) {
    return HTTP.post('group-faqs', group_faq)
  },

  updateGroupFAQ (group_faq = {}) {
    return HTTP.put('group-faqs/' + group_faq.id, group_faq)
  },

  destroyGroupFAQ (group_faq = {}) {
    return HTTP.delete('group-faqs/' + group_faq.id)
  },

  approvalGroupFAQ (group_faq = {}) {
    return HTTP.post('group-faqs/' + group_faq.id + '/approval')
  },

  rejectGroupFAQ (group_faq = {}) {
    return HTTP.post('group-faqs/' + group_faq.id + '/rejection')
  }

}



// WEBPACK FOOTER //
// ./src/service/group-faq.js